<template>
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_25650_42602)">
            <rect width="16" height="16" rx="8" fill="#AE1C28" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M-4.05859 10.7254H20.024V5.37378H-4.05859V10.7254Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M-4 16.7H20V10.7H-4V16.7Z"
                fill="#21468B"
            />
        </g>
        <defs>
            <clipPath id="clip0_25650_42602">
                <rect width="16" height="16" rx="8" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "NetherlandsFlagIcon",
});
</script>
